import React from "react";

export const FaceGuide = ({ hint = "Centralize o rosto no contorno" }) => (
  <div className="pointer-events-none absolute inset-0" data-testid="face-guide">
    <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet" className="h-full w-full">
      <defs>
        <mask id="face-guide-mask">
          <rect width="100" height="100" fill="white" />
          <ellipse cx="50" cy="46" rx="24" ry="31" fill="black" />
        </mask>
      </defs>
      <rect width="100" height="100" fill="rgba(15,23,42,0.45)" mask="url(#face-guide-mask)" />
      <ellipse cx="50" cy="46" rx="24" ry="31" fill="none" stroke="white" strokeWidth="0.8" strokeDasharray="3 2" />
    </svg>
    <p className="absolute inset-x-0 bottom-2 text-center text-xs font-semibold text-white drop-shadow" data-testid="face-guide-hint">{hint}</p>
  </div>
);
